import React from 'react'

/**
 * PRIMARY BUTTON
 * @param {{ label: string }} props 
 * @returns {JSX.Element}
 */
function PrimaryBtn({ label, ...rest }) {
  return (
    <button
      type='button'
      className="btn py-3 uppercase tracking-wide font-medium text-sm text-white bg-teal-700 hover:bg-teal-800 transition-colors hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
      {...rest}
    >
      {label}
    </button>
  )
}

export default PrimaryBtn